"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsValidTrimStringMinLength = exports.ExactNumberLength = exports.MaxNumberLength = void 0;
const class_validator_1 = require("class-validator");
let MaxNumberLength = class MaxNumberLength {
    validate(numberTest, args) {
        const maxLength = args.constraints[0];
        const numberStr = numberTest.toString();
        const isValid = numberStr.length <= maxLength;
        return isValid;
    }
    defaultMessage(args) {
        const maxLength = args.constraints[0];
        return `$property must not be longer than ${maxLength}`;
    }
};
exports.MaxNumberLength = MaxNumberLength;
exports.MaxNumberLength = MaxNumberLength = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'maxNumberLength', async: false })
], MaxNumberLength);
let ExactNumberLength = class ExactNumberLength {
    validate(numberTest, args) {
        const maxLength = args.constraints[0];
        const numberStr = numberTest.toString();
        const isValid = numberStr.length === maxLength;
        return isValid;
    }
    defaultMessage(args) {
        const maxLength = args.constraints[0];
        return `$property length must be exactly ${maxLength}`;
    }
};
exports.ExactNumberLength = ExactNumberLength;
exports.ExactNumberLength = ExactNumberLength = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'exactNumberLength', async: false })
], ExactNumberLength);
let IsValidTrimStringMinLength = class IsValidTrimStringMinLength {
    validate(str, args) {
        const minLength = args.constraints[0];
        const trimmedString = str.trim();
        const isValid = trimmedString.length >= minLength;
        return isValid;
    }
    defaultMessage(args) {
        const maxLength = args.constraints[0];
        return `$property length greater than or equal to ${maxLength}`;
    }
};
exports.IsValidTrimStringMinLength = IsValidTrimStringMinLength;
exports.IsValidTrimStringMinLength = IsValidTrimStringMinLength = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ async: false })
], IsValidTrimStringMinLength);
//# sourceMappingURL=CustomValidation.js.map